import React from 'react';
import Typography from '@clasohlson/co-ui-components/Typography';
import styled from 'styled-components';
import { ICopOrder } from '../../orderModel';
import { useGlobalStateValue } from '../../store/globalState';
import { BorderedBox } from '../layout/BorderedBox';
import { BoxHeader } from '../layout/BoxHeader';
import { formatDate, formatPrice, getCountryCodeFromUrl, useTranslation } from '../../utils';
import RetTypography from '../layout/RetTypography';

const CustomGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 14px;
  > div {
    margin: 1rem 0;
    padding: 0 1.25rem;
    border-right: 1px solid #d9d5d5;
    /* &:nth-child(1) {
      padding-left: 0;
    } */
    &:nth-child(4) {
      border-right: 0;
    }
  }
  @media screen and (max-width: 600px) {
    > div {
      padding: 0.75rem 0.875rem;
      border-style: solid;
      border-color: #d9d5d5;
      margin: 0;
      &:nth-child(odd) {
        border-width: 0 1px 1px 0;
      }
      &:nth-child(even) {
        border-width: 0 0 1px 0;
      }
      /* &:nth-child(1),
      &:nth-child(2) {
        padding-top: 0;
      } */
      &:nth-child(3),
      &:nth-child(4) {
        border-bottom: 0;
      }
    }
  }
`;

const CustomColumn = styled.div`
  display: flex;
  width: 25%;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    width: 50%;
  }
`;

const StyledBorderedBox = styled(BorderedBox)`
  margin-bottom: 1rem;
  padding: 0;
  @media screen and (max-width: 600px) {
    margin-bottom: 1rem;
  }
`;

interface Props {
  order: ICopOrder;
}

export const OrderOverview: React.FC<Props> = ({ order }) => {
  const {
    state: { returnQuery },
  } = useGlobalStateValue();

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <BoxHeader>
        <Typography color="#000" variant="h5" tag="span">
          <strong>{t('orderNo')}</strong> {returnQuery?.orderNumber || ''}
        </Typography>
      </BoxHeader>
      <StyledBorderedBox
        topSpacing="medium"
        bottomSpacing="medium"
        rightSpacing="large"
        leftSpacing="large"
      >
        <CustomGrid>
          <CustomColumn className="mobile-bb-br">
            <span>
              <strong>{t('date')}</strong>
            </span>
            <RetTypography fontSize="14px" mobileFontSize="12px">
              {formatDate(order.createdDate)}
            </RetTypography>
          </CustomColumn>
          <CustomColumn>
            <span>
              <strong>{t('products')}</strong>
            </span>
            <RetTypography fontSize="14px" mobileFontSize="12px">
              {order.lineItems.length}
            </RetTypography>
          </CustomColumn>
          <CustomColumn>
            <span>
              <strong>{t('amount')}</strong>
            </span>
            <RetTypography fontSize="14px" mobileFontSize="12px">
              {formatPrice(
                order.orderPriceInfo.totalSum.priceIncludingVat,
                getCountryCodeFromUrl(),
              )}
            </RetTypography>
          </CustomColumn>
          <CustomColumn>
            <span>
              <strong>{t('status')}</strong>
            </span>
            <RetTypography fontSize="14px" mobileFontSize="12px">
              Status
            </RetTypography>
          </CustomColumn>
        </CustomGrid>
      </StyledBorderedBox>
    </React.Fragment>
  );
};
